import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SalesAndDealsTable from "./SalesAndDealsTable";
import { FiPlus, FiTag } from "react-icons/fi";

import useApi from "../../Hooks/useApi";
import { DelteSales, getsales } from "../../api/getapi";
import { toggleSaleStatus } from "../../api/postapi";
import "./SalesAndDeals.css";
function SalesAndDeals() {
  const navigate = useNavigate();
  const { data: items, request: getSales } = useApi(getsales);
  const { request: deleteSales } = useApi(DelteSales);
  const { request: toggleStatus } = useApi(toggleSaleStatus, { hasCatchError: true });

  useEffect(() => {
    getSales();
  }, []);

  const onDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this deal?")) {
      return;
    }
    await deleteSales(id);
    getSales();
  };

  const handleToggleStatus = async (id) => {
    await toggleStatus(id);
    getSales();
  };

  const handleEdit = (deal) => {
    navigate(`/marketplace-options/sales-deals/edit/${deal.sale_id}`);
  };

  return (
    <div className="container-fluid">
      <div className="sd-page-header">
        <div className="sd-page-identity">
          <span className="sd-page-icon">
            <FiTag />
          </span>
          <h1 className="sd-page-title">Sales &amp; Deals</h1>
          <span className="sd-page-subtitle">Create and manage promotional campaigns for your marketplace</span>
        </div>
        <button
          type="button"
          className="sd-btn-toggle sd-btn-create"
          onClick={() => navigate("/marketplace-options/sales-deals/create")}
        >
          <FiPlus /> Add New Deal
        </button>
      </div>

      <div className="sd-page-body">
        <SalesAndDealsTable data={items} onEdit={handleEdit} onDelete={onDelete} onToggleStatus={handleToggleStatus} onAddNew={() => navigate("/marketplace-options/sales-deals/create")} />
      </div>
    </div>
  );
}

export default SalesAndDeals;
